import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OutlinePreviewComponent } from './outline-preview.component';

const routes: Routes = [
  {
    path: '',
    component: OutlinePreviewComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OutlinePreviewRoutingModule { }
